var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.visible
    ? _c("div", { staticClass: "loading-wrap" }, [
        _vm._v("\n    " + _vm._s(_vm.visible + "") + "\n    "),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "loading-box" },
          [
            _c("a-spin", {
              staticStyle: { color: "#008dff" },
              attrs: { indicator: _vm.indicator }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a51a0480", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a51a0480","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/serve/Loading/loading.vue
// module id = 8u3f
// module chunks = 125